/**
 * Yerleşim/boşluk sabitleri — bugüne kadar her dosyada elle tekrarlanan değerlerin
 * tek kaynağı (sayfa dolgusu, kabuk ölçüleri, konteyner genişliği, yarıçaplar).
 * `theme.spacing` 8px tabanlıdır; buradaki `pagePadding*` gibi alanlar `sx` prop'una
 * doğrudan geçmek için spacing birimi (sayı) cinsindendir.
 */
export const LAYOUT = {
  /** Sidebar Drawer genişliği (açık / daraltılmış). */
  drawerWidth: 264,
  drawerCollapsedWidth: 72,
  /** Fixed Topbar yüksekliği (px). */
  topbarHeight: 60,
  /** Topbar altındaki breadcrumb şeridi yüksekliği (px). */
  breadcrumbBarHeight: 40,
  /** Ana içerik maksimum genişliği (px) — geniş ekranlarda satır uzunluğunu sınırlar. */
  contentMaxWidth: 1440,
  /** Ana içerik dolgusu — `sx` spacing birimi. */
  pagePaddingX: { xs: 2, sm: 3 },
  pagePaddingY: { xs: 2, sm: 3 },
  /** Kartlar/bölümler arası dikey boşluk — `sx` spacing birimi. */
  sectionGap: 3,
  /** Yarıçaplar (px). */
  cardRadius: 14,
  controlRadius: 10,
  pillRadius: 999,
} as const;

/** z-index katmanları — MUI varsayılanlarıyla uyumlu (drawer 1200, appBar 1100 tabanı). */
export const Z = {
  appBar: 1200,
  breadcrumbBar: 1150,
  drawer: 1100,
  stickyCart: 2,
} as const;
